import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { datesDefault } from "../components/AssetManagement/Overview/Trends/helpers/funcs/datesDefault";

const initialState = {
  trendsDashboardExecuteQueriesData: [],
  selectedSharedUid: [],
  fetchBy: "site",
  dataSet:
    new URLSearchParams(window.location.search).get("dataSet") || "click",
  selectedStartDate: dayjs().startOf("month"),
  selectedEndDate: dayjs().endOf("month"),
  showTrendsTabs: false,
  show: false,
  display: false,
  defaultWebsiteUid: null,
  defaultDimension: null,
  selectedTimeUnit: datesDefault[0],
  selectedTimeUnitCac: datesDefault[0],
  selectedTimeUnitImp: datesDefault[0],
  selectedTimeUnitCpc: datesDefault[0],
  selectedTimeUnitCi: datesDefault[0],
  selectedTimeUnitCo: datesDefault[0],
  selectedTimeUnitCoi: datesDefault[0],
  selectedTimeUnitEpc: datesDefault[0],
  selectedTimeUnitFr: datesDefault[0],
  selectedTimeUnitCpa: datesDefault[0],
  selectedTimeUnitCpapv: datesDefault[0],
  selectedTimeUnitAcpa: datesDefault[0],
  selectedTimeUnitCr: datesDefault[0],
  selectedTimeUnitFtd: datesDefault[0],
  selectedTimeUnitGftdqftd: datesDefault[0],
  selectedTimeUnitPftd: datesDefault[0],
  selectedTimeUnitPv: datesDefault[0],
  selectedTimeUnitNrpf: datesDefault[0],
  selectedTimeUnitP: datesDefault[0],
  selectedTimeUnitS: datesDefault[0],
  selectedTimeUnitTi: datesDefault[0],
  selectedTimeUnitRs: datesDefault[0],
  selectedTimeUnitRspv: datesDefault[0],
  selectedTimeUnitArspd: datesDefault[0],
  organizationOptions: [],
  organizationDimensions: [],
  trafficSourceData: [],
  geoData: [],
  filterBizLayerQueryDataMap: {},
  trendsFilters: [],
  isLoadingFilter: false,
  activityNotesDataGlobal: [],
  loadingNotes: false,
  cacDataRedux: [],
  impDataRedux: [],
  cpcDataRedux: [],
  ciDataRedux: [],
  coDataRedux: [],
  coiDataRedux: [],
  epcDataRedux: [],
  frDataRedux: [],
  cpaDataRedux: [],
  cpapvDataRedux: [],
  acpaDataRedux: [],
  crDataRedux: [],
  ftdDataRedux: [],
  gftdqftdDataRedux: [],
  pftdDataRedux: [],
  pvDataRedux: [],
  nrpfDataRedux: [],
  pDataRedux: [],
  sDataRedux: [],
  tiDataRedux: [],
  rsDataRedux: [],
  rspvDataRedux: [],
  arspdDataRedux: [],

  //Trends Breakdown Slice
  countryDataTrendsBreakdown: [],
  trafficSourceDataTrendsBreakdown: [],
  campaignDataTrendsBreakdown: [],
  adGroupDataTrendsBreakdown: [],
  keywordMatchTypeDataTrendsBreakdown: [],
  brandsDataTrendsBreakdown: [],
  groupBy: null,
  trafficSourceBD: null,
  inCampaignBD: null,
  selectedKeyword: null,
  selectedMatchTypeFilterBD: null,
  selectedCampaignFilterBD: null,
  selectedAdGroupFilterBD: null,
  selectedTrafficSourceFilterBD: null,
  selectedSearchBrand: null,
  isLoadingBDAds: false,
  isChildrenAPILoadingBDAds: false,
  loadingTrafficSourceFilters: false,
};

const trendsSlice = createSlice({
  name: "trends",
  initialState,
  reducers: {
    setTrendsDashboardExecuteQueriesData: (state, action) => {
      state.trendsDashboardExecuteQueriesData = action.payload;
    },
    setFetchBy: (state, action) => {
      state.fetchBy = action.payload;
    },
    setDataSet: (state, action) => {
      state.dataSet = action.payload;
    },
    setSelectedStartDate: (state, action) => {
      state.selectedStartDate = action.payload;
    },
    setSelectedEndDate: (state, action) => {
      state.selectedEndDate = action.payload;
    },
    setShowTrendsTabs: (state, action) => {
      state.showTrendsTabs = action.payload;
    },
    setShow: (state, action) => {
      state.show = action.payload;
    },
    setDisplay: (state, action) => {
      state.display = action.payload;
    },
    setSelectedTimeUnit: (state, action) => {
      state.selectedTimeUnit = action.payload;
    },
    setSelectedTimeUnitCac: (state, action) => {
      state.selectedTimeUnitCac = action.payload;
    },
    setSelectedTimeUnitImp: (state, action) => {
      state.selectedTimeUnitImp = action.payload;
    },
    setSelectedTimeUnitCpc: (state, action) => {
      state.selectedTimeUnitCpc = action.payload;
    },
    setSelectedTimeUnitCi: (state, action) => {
      state.selectedTimeUnitCi = action.payload;
    },
    setSelectedTimeUnitCo: (state, action) => {
      state.selectedTimeUnitCo = action.payload;
    },
    setSelectedTimeUnitCoi: (state, action) => {
      state.selectedTimeUnitCoi = action.payload;
    },
    setSelectedTimeUnitEpc: (state, action) => {
      state.selectedTimeUnitEpc = action.payload;
    },
    setSelectedTimeUnitFr: (state, action) => {
      state.selectedTimeUnitFr = action.payload;
    },
    setSelectedTimeUnitCpa: (state, action) => {
      state.selectedTimeUnitCpa = action.payload;
    },
    setSelectedTimeUnitCpapv: (state, action) => {
      state.selectedTimeUnitCpapv = action.payload;
    },
    setSelectedTimeUnitAcpa: (state, action) => {
      state.selectedTimeUnitAcpa = action.payload;
    },
    setSelectedTimeUnitCr: (state, action) => {
      state.selectedTimeUnitCr = action.payload;
    },
    setSelectedTimeUnitFtd: (state, action) => {
      state.selectedTimeUnitFtd = action.payload;
    },
    setSelectedTimeUnitGftdqftd: (state, action) => {
      state.selectedTimeUnitGftdqftd = action.payload;
    },
    setSelectedTimeUnitPftd: (state, action) => {
      state.selectedTimeUnitPftd = action.payload;
    },
    setSelectedTimeUnitPv: (state, action) => {
      state.selectedTimeUnitPv = action.payload;
    },
    setSelectedTimeUnitNrpf: (state, action) => {
      state.selectedTimeUnitNrpf = action.payload;
    },
    setSelectedTimeUnitP: (state, action) => {
      state.selectedTimeUnitP = action.payload;
    },
    setSelectedTimeUnitS: (state, action) => {
      state.selectedTimeUnitS = action.payload;
    },
    setSelectedTimeUnitTi: (state, action) => {
      state.selectedTimeUnitTi = action.payload;
    },
    setSelectedTimeUnitRs: (state, action) => {
      state.selectedTimeUnitRs = action.payload;
    },
    setSelectedTimeUnitRspv: (state, action) => {
      state.selectedTimeUnitRspv = action.payload;
    },
    setSelectedTimeUnitArspd: (state, action) => {
      state.selectedTimeUnitArspd = action.payload;
    },
    setOrganizationOptions: (state, action) => {
      state.organizationOptions = action.payload;
    },
    setOrganizationDimensions: (state, action) => {
      state.organizationDimensions = action.payload;
    },

    setTrafficSourceData: (state, action) => {
      state.trafficSourceData = action.payload;
    },
    setGeoData: (state, action) => {
      state.geoData = action.payload;
    },
    setFilterBizLayerQueryDataById: (state: any, action) => {
      const { key, data } = action.payload;
      state.filterBizLayerQueryDataMap[key] = data;
    },
    clearFilterBizLayerQueryDataMap: (state) => {
      state.filterBizLayerQueryDataMap = {};
    },
    setTrendsFilter(state: any, action) {
      // Replace if key exists, else push
      const existingIndex = state.trendsFilters?.findIndex(
        (item: any) => item.key === action.payload.key
      );
      if (existingIndex >= 0) {
        state.trendsFilters[existingIndex] = action.payload;
      } else {
        state.trendsFilters.push(action.payload);
      }
    },
    clearTrendsFilters(state) {
      state.trendsFilters = [];
    },
    setSelectedSharedUid(state, action) {
      state.selectedSharedUid = action.payload;
    },

    setIsLoadingFilter(state, action) {
      state.isLoadingFilter = action.payload;
    },
    setActivityNotesDataGlobal(state, action) {
      state.activityNotesDataGlobal = action.payload;
    },

    setDefaultWebsiteUid(state, action) {
      state.defaultWebsiteUid = action.payload;
    },
    setDefaultDimension(state, action) {
      state.defaultDimension = action.payload;
    },
    setLoadingNotes(state, action) {
      state.loadingNotes = action.payload;
    },
    setCacDataRedux(state, action) {
      state.cacDataRedux = action.payload;
    },
    setImpDataRedux(state, action) {
      state.impDataRedux = action.payload;
    },
    setCpcDataRedux(state, action) {
      state.cpcDataRedux = action.payload;
    },
    setCiDataRedux(state, action) {
      state.ciDataRedux = action.payload;
    },
    setCoDataRedux(state, action) {
      state.coDataRedux = action.payload;
    },
    setCoiDataRedux(state, action) {
      state.coiDataRedux = action.payload;
    },
    setEpcDataRedux(state, action) {
      state.epcDataRedux = action.payload;
    },
    setFrDataRedux(state, action) {
      state.frDataRedux = action.payload;
    },
    setCpaDataRedux(state, action) {
      state.cpaDataRedux = action.payload;
    },
    setCpapvDataRedux(state, action) {
      state.cpapvDataRedux = action.payload;
    },
    setAcpaDataRedux(state, action) {
      state.acpaDataRedux = action.payload;
    },
    setCrDataRedux(state, action) {
      state.crDataRedux = action.payload;
    },
    setFtdDataRedux(state, action) {
      state.ftdDataRedux = action.payload;
    },
    setGftdqftdDataRedux(state, action) {
      state.gftdqftdDataRedux = action.payload;
    },
    setPftdDataRedux(state, action) {
      state.pftdDataRedux = action.payload;
    },
    setPvDataRedux(state, action) {
      state.pvDataRedux = action.payload;
    },
    setNrpfDataRedux(state, action) {
      state.nrpfDataRedux = action.payload;
    },
    setPDataRedux(state, action) {
      state.pDataRedux = action.payload;
    },
    setSDataRedux(state, action) {
      state.sDataRedux = action.payload;
    },
    setTiDataRedux(state, action) {
      state.tiDataRedux = action.payload;
    },
    setRsDataRedux(state, action) {
      state.rsDataRedux = action.payload;
    },
    setRspvDataRedux(state, action) {
      state.rspvDataRedux = action.payload;
    },
    setArspdDataRedux(state, action) {
      state.arspdDataRedux = action.payload;
    },
    clearAllTimeUnits: (state) => {
      state.selectedTimeUnit = datesDefault[0];
      state.selectedTimeUnitCac = datesDefault[0];
      state.selectedTimeUnitImp = datesDefault[0];
      state.selectedTimeUnitCpc = datesDefault[0];
      state.selectedTimeUnitCi = datesDefault[0];
      state.selectedTimeUnitCo = datesDefault[0];
      state.selectedTimeUnitCoi = datesDefault[0];
      state.selectedTimeUnitEpc = datesDefault[0];
      state.selectedTimeUnitFr = datesDefault[0];
      state.selectedTimeUnitCpa = datesDefault[0];
      state.selectedTimeUnitCpapv = datesDefault[0];
      state.selectedTimeUnitAcpa = datesDefault[0];
      state.selectedTimeUnitCr = datesDefault[0];
      state.selectedTimeUnitFtd = datesDefault[0];
      state.selectedTimeUnitGftdqftd = datesDefault[0];
      state.selectedTimeUnitPftd = datesDefault[0];
      state.selectedTimeUnitPv = datesDefault[0];
      state.selectedTimeUnitNrpf = datesDefault[0];
      state.selectedTimeUnitP = datesDefault[0];
      state.selectedTimeUnitS = datesDefault[0];
      state.selectedTimeUnitTi = datesDefault[0];
      state.selectedTimeUnitRs = datesDefault[0];
      state.selectedTimeUnitRspv = datesDefault[0];
      state.selectedTimeUnitArspd = datesDefault[0];
    },
    clearAllTimeUnitsData: (state) => {
      state.cacDataRedux = [];
      state.impDataRedux = [];
      state.cpcDataRedux = [];
      state.ciDataRedux = [];
      state.coDataRedux = [];
      state.coiDataRedux = [];
      state.epcDataRedux = [];
      state.frDataRedux = [];
      state.cpaDataRedux = [];
      state.cpapvDataRedux = [];
      state.acpaDataRedux = [];
      state.crDataRedux = [];
      state.ftdDataRedux = [];
      state.gftdqftdDataRedux = [];
      state.pftdDataRedux = [];
      state.pvDataRedux = [];
      state.nrpfDataRedux = [];
      state.pDataRedux = [];
      state.sDataRedux = [];
      state.tiDataRedux = [];
      state.rsDataRedux = [];
      state.rspvDataRedux = [];
      state.arspdDataRedux = [];
    },
    setCountryDataTrendsBreakdown: (state, action) => {
      state.countryDataTrendsBreakdown = action.payload;
    },
    setTrafficSourceDataTrendsBreakdown: (state, action) => {
      state.trafficSourceDataTrendsBreakdown = action.payload;
    },
    setCampaignDataTrendsBreakdown: (state, action) => {
      state.campaignDataTrendsBreakdown = action.payload;
    },
    setAdGroupDataTrendsBreakdown: (state, action) => {
      state.adGroupDataTrendsBreakdown = action.payload;
    },
    setKeywordMatchTypeDataTrendsBreakdown: (state, action) => {
      state.keywordMatchTypeDataTrendsBreakdown = action.payload;
    },

    setBrandsDataTrendsBreakdown: (state, action) => {
      state.brandsDataTrendsBreakdown = action.payload;
    },
    setGroupBy: (state, action) => {
      state.groupBy = action.payload;
    },
    setTrafficSourceBD: (state, action) => {
      state.trafficSourceBD = action.payload;
    },
    setInCampaignBD: (state, action) => {
      state.inCampaignBD = action.payload;
    },
    setSelectedKeyword: (state, action) => {
      state.selectedKeyword = action.payload;
    },

    setSelectedMatchTypeFilterBD: (state, action) => {
      state.selectedMatchTypeFilterBD = action.payload;
    },
    setSelectedCampaignFilterBD: (state, action) => {
      state.selectedCampaignFilterBD = action.payload;
    },
    setSelectedAdGroupFilterBD: (state, action) => {
      state.selectedAdGroupFilterBD = action.payload;
    },
    setSelectedTrafficSourceFilterBD: (state, action) => {
      state.selectedTrafficSourceFilterBD = action.payload;
    },
    setSelectedSearchBrand: (state, action) => {
      state.selectedSearchBrand = action.payload;
    },
    setIsLoadingBDAds: (state, action) => {
      state.isLoadingBDAds = action.payload;
    },
    setIsChildrenAPILoadingBDAds: (state, action) => {
      state.isChildrenAPILoadingBDAds = action.payload;
    },
    // Add this to your trendsSlice reducers
    removeTrendsFilter: (state, action) => {
      state.trendsFilters = state.trendsFilters.filter(
        (filter: any) => filter.key !== action.payload
      );
    },
    setLoadingTrafficSourceFilters: (state, action) => {
      state.loadingTrafficSourceFilters = action.payload;
    },
  },
});

export const {
  setTrendsDashboardExecuteQueriesData,
  setFetchBy,
  setDataSet,
  setSelectedStartDate,
  setSelectedEndDate,
  setShowTrendsTabs,
  setShow,
  setDisplay,
  setSelectedTimeUnit,
  setSelectedTimeUnitCac,
  setOrganizationOptions,
  setOrganizationDimensions,
  setTrafficSourceData,
  setGeoData,
  setFilterBizLayerQueryDataById,
  clearFilterBizLayerQueryDataMap,
  setTrendsFilter,
  clearTrendsFilters,
  setSelectedSharedUid,
  setIsLoadingFilter,
  setActivityNotesDataGlobal,
  setLoadingNotes,
  setCacDataRedux,
  clearAllTimeUnits,
  clearAllTimeUnitsData,
  setImpDataRedux,
  setSelectedTimeUnitImp,
  setCpcDataRedux,
  setSelectedTimeUnitCpc,
  setCiDataRedux,
  setSelectedTimeUnitCi,
  setCoDataRedux,
  setSelectedTimeUnitCo,
  setCoiDataRedux,
  setSelectedTimeUnitCoi,
  setEpcDataRedux,
  setSelectedTimeUnitEpc,
  setFrDataRedux,
  setSelectedTimeUnitFr,
  setCpaDataRedux,
  setSelectedTimeUnitCpa,
  setCpapvDataRedux,
  setSelectedTimeUnitCpapv,
  setAcpaDataRedux,
  setSelectedTimeUnitAcpa,
  setCrDataRedux,
  setSelectedTimeUnitCr,
  setFtdDataRedux,
  setSelectedTimeUnitFtd,
  setGftdqftdDataRedux,
  setSelectedTimeUnitGftdqftd,
  setPftdDataRedux,
  setSelectedTimeUnitPftd,
  setPvDataRedux,
  setSelectedTimeUnitPv,
  setNrpfDataRedux,
  setSelectedTimeUnitNrpf,
  setPDataRedux,
  setSelectedTimeUnitP,
  setSDataRedux,
  setSelectedTimeUnitS,
  setTiDataRedux,
  setSelectedTimeUnitTi,
  setRsDataRedux,
  setSelectedTimeUnitRs,
  setRspvDataRedux,
  setSelectedTimeUnitRspv,
  setArspdDataRedux,
  setSelectedTimeUnitArspd,
  setCountryDataTrendsBreakdown,
  setTrafficSourceDataTrendsBreakdown,
  setCampaignDataTrendsBreakdown,
  setAdGroupDataTrendsBreakdown,
  setKeywordMatchTypeDataTrendsBreakdown,
  setBrandsDataTrendsBreakdown,
  setGroupBy,
  setTrafficSourceBD,
  setInCampaignBD,
  setSelectedKeyword,
  setSelectedMatchTypeFilterBD,
  setSelectedCampaignFilterBD,
  setSelectedAdGroupFilterBD,
  setSelectedTrafficSourceFilterBD,
  setSelectedSearchBrand,
  setIsLoadingBDAds,
  setIsChildrenAPILoadingBDAds,
  removeTrendsFilter,
  setLoadingTrafficSourceFilters,
  setDefaultWebsiteUid,
  setDefaultDimension,
} = trendsSlice.actions;
export default trendsSlice.reducer;
